import { CENTERS } from '@/common/types/centers';

/**
 * Whether the factor page should call Katibe payment-methods / balance APIs
 * and show the Katibe wallet payment-method UI.
 *
 * - Online visit (5532): always Katibe (consult-payment → Katibe).
 * - In-person / hospital: only when GrowthBook `use-katibe-payment-for-earnest-factor`
 *   is on for this user_center (same flag that already switches copy + payment path).
 * - Otherwise payment is center-payment with the center's own gateway — no Katibe UI.
 */
export function usesKatibeFactorPayment(centerId: string, earnestKatibeFlagOn: boolean): boolean {
  return centerId === CENTERS.CONSULT || earnestKatibeFlagOn;
}
